const projectsData = [
  {
    id: 1,
    title: "Movie Search App with React",
    logo: "trendflix-logo.png",
    topics: [
      "react",
      "tmdb-api",
      "material-ui",
      "react-router",
      "responsive-design",
    ],
    description:
      "This is a multi-page React app, that takes advantage of TMDB API and allows users to browse movies, watch trailers, discover upcoming and trending titles.",
    thumbnail: "trendflix-thumbnail.png",
    websiteLink: "https://cosminmoldovan.github.io/trendflix/",
    githubLink: "https://github.com/cosminmoldovan/trendflix",
    background: "trendflix-bg.png",
  },
  {
    id: 2,
    title: "Video Game Discovery Web App",
    topics: [
      "react",
      "typescript",
      "video-games-api",
      "chakra-ui",
      "custom-data-fetching",
      "filtering-and-searching",
      "dark-mode",
    ],
    description:
      "GameHub is a video game discovery web application that helps you find new and exciting games to play. You can search for games by platform, genre and more.",
    thumbnail: "gamehub-thumbnail.png",
    websiteLink: "https://cm-gamehub.vercel.app/",
    githubLink: "https://github.com/cosminmoldovan/game-hub",
    background: "gamehub-bg.png",
  },
  {
    id: 3,
    title: "Responsive Landing Page",
    logo: "remindme-logo.png",
    topics: ["html5", "css3", "sass", "bem-methodology", "modern-ui"],
    description:
      "This is a responsive and modern landing page designed in Figma, with a focus on the UI. Developed using Sass features and BEM methodology.",
    thumbnail: "remindme-thumbnail.png",
    websiteLink: "https://cosminmoldovan.github.io/remindme/",
    githubLink: "https://github.com/cosminmoldovan/remindme",
    background: "remindme-bg.png",
  },
  {
    id: 4,
    title: "Educational Coding Game for Kids",
    topics: [
      "modern-web-tech",
      "html5-apis",
      "vanila-js",
      "dom-manipulations",
      "canvas",
      "css3-features",
      "local-storage",
    ],
    description:
      "KidoCode is a user-friendly, web-based educational game that provides a basic understanding of programming logic through interactive code blocks.",
    thumbnail: "kidocode-thumbnail.png",
    websiteLink: "https://cosminmoldovan.github.io/kidocode/",
    githubLink: "https://github.com/cosminmoldovan/kidocode",
    background: "kidocode-bg.png",
  },
];
export default projectsData;
